import { useState } from 'react'

import { Button } from '@/components/ui/button'
import { AGENT_NAME } from './accountModel'
import { PANEL_WIDTH } from './AgentSurface'
import { AgentTab } from './AgentTabBar'
import { GETTING_STARTED_THREAD, ONBOARDING_THREAD } from './contacts'
import { FleetDesktopPlacement } from './FleetDesktopPlacement'
import { OnboardingMock } from './OnboardingMock'
import { DESKTOP_WIDTH, OptionSection } from './OptionSection'
import { ReactAppMock } from './ReactAppMock'

/** Option 3, the app on its own — no desktop, and the sign-up beside it. */
export function FleetAssistantOptionSection({
  shellClass,
  shellHeight,
}: {
  shellClass: string
  shellHeight: number
}) {
  const [notificationId, setNotificationId] = useState(0)

  return (
    <OptionSection
      title="Option 3: Fleet assistant"
      action={
        <Button size="sm" variant="outline" onClick={() => setNotificationId((id) => id + 1)}>
          Send a notification
        </Button>
      }
      panes={[
        {
          label: 'React app',
          width: PANEL_WIDTH,
          content: <ReactAppMock height={shellHeight} notified={notificationId > 0} connect blankChat />,
        },
        {
          label: 'Onboarding',
          width: PANEL_WIDTH,
          startsGroup: true,
          content: <OnboardingMock height={shellHeight} thread={ONBOARDING_THREAD} />,
        },
        {
          label: 'Getting started',
          width: PANEL_WIDTH,
          content: (
            <OnboardingMock height={shellHeight} thread={GETTING_STARTED_THREAD} agentName={AGENT_NAME} />
          ),
        },
        {
          label: 'Invite',
          width: PANEL_WIDTH,
          content: (
            <ReactAppMock height={shellHeight} connect blankChat initialTab={AgentTab.CONNECT} inviteOpen />
          ),
        },
        {
          label: 'Desktop',
          width: DESKTOP_WIDTH,
          startsGroup: true,
          content: <FleetDesktopPlacement notificationId={notificationId} className={shellClass} />,
        },
      ]}
    />
  )
}
